(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  customElements.define(
    'prices-checkout',
    class PricesCheckout extends HTMLElement {
      constructor() {
        super();

        this.handleMutations = this.handleMutations.bind(this);
        this.updateComparePrice = this.updateComparePrice.bind(this);
        this.setupPriceElements = this.setupPriceElements.bind(this);
      }

      connectedCallback() {
        this.priceElement = this.querySelector('.money');
        this.comparePriceElement = this.querySelector('s');

        const observerConfig = {
          characterData: true,
          childList: true,
          subtree: true,
        };

        this.observer = new MutationObserver(this.handleMutations);
        this.observer.observe(this.priceElement, observerConfig);

        this.checkForElementsInterval = setInterval(() => {
          this.setupPriceElements();
        }, 100);

        this.updateComparePrice();
      }

      setupPriceElements() {
        if (this.closest('footer').querySelector('.ship-insurance')) {
          this.tmPriceElement = this.closest('footer').querySelector('.tm_price');
          this.checkbox = this.closest('footer').querySelector('.tm_switch_label');

          if (this.tmPriceElement && this.checkbox) {
            this.checkbox.addEventListener('change', this.updateComparePrice);

            // Annuler l'intervalle une fois que les éléments ont été trouvés
            clearInterval(this.checkForElementsInterval);
          }
        }
      }

      updateComparePrice() {
        const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
          ? window.themeVariables.settings.moneyWithCurrencyFormat
          : window.themeVariables.settings.moneyFormat;

        if (this.checkbox && this.checkbox.checked) {
          const additionalPrice = parseFloat(this.tmPriceElement.textContent.replace(/[^\d.-]/g, ''));

          this.comparePriceElement.innerHTML = formatMoney(
            parseFloat(this.comparePriceElement.dataset.originalCompare) + additionalPrice * 100,
            currencyFormat
          );
        } else {
          this.comparePriceElement.innerHTML = formatMoney(
            parseFloat(this.comparePriceElement.dataset.originalCompare),
            currencyFormat
          );
        }
      }

      handleMutations(mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            this.updateComparePrice();
            this.observer.disconnect();
          }
        }
      }
    }
  );

  class giftWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.textarea = this.closest('cart-drawer').querySelector('textarea');

      this.querySelector('input').addEventListener('change', () => {
        if (this.querySelector('input').checked) {
          this.textarea.value += `${this.closest('line-item').dataset.title} : It's a gift\n`;
        } else {
          this.textarea.value = this.textarea.value.replace(
            `${this.closest('line-item').dataset.title} : It's a gift\n`,
            ''
          );
        }
      });
    }
  }
  customElements.define('gift-wrapper', giftWrapper);

  class UpsellVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.formId = this.closest('.upsell-product').querySelector('.upsell-product__add-form input[name="id"]');

      this.querySelector('select.visually-hidden').addEventListener('change', () => {
        this.formId.value = this.querySelector('select').value;
      });
    }
  }
  customElements.define('upsell-variants', UpsellVariants);

  class UpsellProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new window.ThemeFlickity(this, {
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        width: 'calc(100% - 25px)',
        gap: 10,
        prevNextButtons: false,
        wrapAround: false,
      });
    }
  }
  customElements.define('upsell-products', UpsellProducts);

  } catch(e) { console.error(e); }
})();
})();
